// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"91371910","453":"a5dc196b","455":"179a0a1a","977":"6dca6b37"}[chunkId] + ".chunk.js";
};